export const formatAmount = (amount: number | string, notCalc: boolean = false, digits: number = 3) => {
	const t = new Intl.NumberFormat("es-CL", {
		minimumFractionDigits: digits,
		maximumFractionDigits: digits
	});
	if (typeof amount === 'string') {
		amount = parseFloat(amount.replace(',', '.'));
	}
	let mt = notCalc ? amount : amount / 1000 / 1000;
	if (mt < 0) {
		mt = mt * -1;
	}
	return t.format(mt);
}
